// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"86323935","453":"136ea300","980":"5909260a"}[chunkId] + ".chunk.js";
};